import { Title2, Body1, Button } from "@fluentui/react-components";

export default function Forbidden() {
  return (
    <div style={{ textAlign: "center", marginTop: "4rem" }}>
      <Title2>Access denied</Title2>
      <Body1>You don't have permission to view this page.</Body1>
      <div style={{ marginTop: "1.5rem" }}>
        <Button as="a" href="/" appearance="primary">Back to dashboards</Button>
      </div>
    </div>
  );
}
